import {
  BookOpen, GraduationCap, DollarSign, Briefcase, Target, BarChart3, Code,
  Lightbulb, Rocket, Award, Users, Crown, TrendingUp, Mic, Video
} from 'lucide-react';

const MODULE_ICON_MAP = {
  BookOpen, GraduationCap, DollarSign, Briefcase, Target, BarChart3, Code,
  Lightbulb, Rocket, Award, Users, Crown, TrendingUp, Mic, Video
};

export const getModuleIcon = (iconName) => MODULE_ICON_MAP[iconName] || BookOpen;
